import { render } from "./Configurator.vue?vue&type=template&id=0b8a3422"
import script from "./Configurator.vue?vue&type=script&lang=js"
export * from "./Configurator.vue?vue&type=script&lang=js"

import "./Configurator.vue?vue&type=style&index=0&id=0b8a3422&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__